import Breadcrumb from "./Breadcrumb";
import './breadCrumb.scss';

export default Breadcrumb;